import { createAsyncThunk } from "@reduxjs/toolkit";
import getApiUrl from "../../../api";

const asyncRefresh = createAsyncThunk(
    'auth/refresh',
    async function() {
        const refreshToken = localStorage.refresh;
        const promise = await fetch(getApiUrl() + '/api/auth/refresh', {
            method: "POST",
            body: JSON.stringify({refreshToken})
        });

        const json = await promise.json();
        console.log(refreshToken, json);

        return json;
    }
)

export default asyncRefresh;